import React, { Component } from 'react';
import Slider from 'react-slick';

import './Brasseries.css';

import Brasserie from '../Brasserie/Brasserie';

class Brasseries extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="page-container" id="la-brasserie">
        <Slider {...settings}>
          {this.props.brasseries.map(brasserie => (
            <Brasserie brasserie={brasserie.acf} key={brasserie.acf.titre} />
          ))}
        </Slider>
      </div>
    );
  }
}

export default Brasseries;



// WEBPACK FOOTER //
// ./src/Components/Brasseries/Brasseries.js